import { version } from "src/utils/version";

const isProduction = process.env.REACT_APP_ENV === "production";

export default {
    baseHost:
        process.env.REACT_APP_BASE_HOST || "https://staging-api.snackpass.co",
    apiUrl:
        process.env.REACT_APP_API_URL ||
        "https://staging-api.snackpass.co/api/v4",
    gqlUrl:
        process.env.REACT_APP_GQL_URL ||
        "https://staging-api.snackpass.co/graphql",
    menuGqlUrl:
        process.env.REACT_APP_MENU_GQL_URL ||
        "https://staging-graph.snackpass.co/graphql",
    menuBucketUrl:
        process.env.REACT_APP_MENU_BUCKET_URL ||
        "https://pub-1beb685e4630468ca9a27a04aa32e657.r2.dev",
    bridgeUrl: (storeId: string) =>
        isProduction
            ? `https://${storeId}.production.bridge.snackpass.co`
            : `https://${storeId}.staging.bridge.snackpass.co`,
    env: process.env.REACT_APP_ENV || "development",

    isProduction,
    isDevEnv: process.env.REACT_APP_ENV === "development",

    /**
     *  This key is different from other platform production keys. This is
     *  because it is useful to separate the restaurant vs. user flow
     */
    PRODUCTION_SEGMENT_API_KEY:
        process.env.REACT_APP_SEGMENT_API_KEY ||
        "rIMsjMDhpF0813sQnOYmxqXSAQHtZDk2",

    SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,

    // Statsig calls feature flags feature gates.
    // Going to use this to have clean separation from existing Flagsmith flags above.
    featureGates: {
        marketplaceOnboarding: "marketplace_onboarding",
        multiMenus: "multi_menus",
        multistoreSalesSummaryReport: "rdb_multistore_sales_summary",
        blacklistedPhoneKioskRewards: "blacklisted_phone_kiosk_rewards",
        rdbReportsHidePayout: "rdb_reports_hide_payout",
        reportsLaborTiles: "rdb_reports_labor_tiles",
        selfServePromoCodeEnabled: "rdb_self_serve_promo_code",
        snackTvSettings: "snack_tv_settings",
        reportsGiftCard: "rdb_reports_gift_card",
        duoSplashScreen: "allow_duo_splash_screen",
        dgcInMenu: "rdb_dgc_in_menu",
        selfServeTaxRate: "self_serve_tax_rate",
        invoices: "invoices",
        tableside: "tableside",
        prepStations: "prep_stations",
        stripeHostedPayoutsOnboarding: "stripe_hosted_payouts_onboarding",
        allowMultipleRefunds: "allow_multiple_refunds",
        prepStationChannelFulfillment: "prep_station_channel_fulfillment",
        enableKeyBasedRegistration: "enable_key_based_registration",
        tables: "register_tables",
        disableTableAssignmentTab: "disable_table_assignment_tab",
        menusEnabled: "enable_menus_v3",
        multipleActiveMenus: "menus_v3_multiple_active",
        reusableGenericPromotionForm: "generic_promo_form",
        deliveryFeeSettings: "delivery_fee_settings",
        tips: "tips",
        dailyReport: "daily_report",
        machines: "machines",
        customHours: "custom_hours",
        lookbookEditor: "lookbook_editor",
        languageSelector: "language_selector",
        newStack: "new_stack",
        giftCardImports: "gift_card_imports",
    },

    /**
     * The stripe public key is intended to be used on client.
     */
    STRIPE_PUBLIC_KEY: isProduction
        ? "pk_live_4jjPSlr2HTi1f0QkTEnXsfLQ"
        : "pk_test_wKhXBkEzIdpkkTd0iEGLmhYR",

    pubnub: {
        conversations: {
            publishKey: process.env.REACT_APP_PUBNUB_CONVERSATIONS_PUBLISH_KEY,
            subscribeKey:
                process.env.REACT_APP_PUBNUB_CONVERSATIONS_SUBSCRIBE_KEY ??
                "not-set",
        },
    },

    STATSIG_ENVIRONMENT: process.env.REACT_APP_STATSIG_ENVIRONMENT,
    STATSIG_KEY: process.env.REACT_APP_STATSIG_KEY,

    firebaseApiKey:
        process.env.REACT_APP_FIREBASE_API_KEY ??
        "AIzaSyDFYc6u8l2RZ0WvoocxpNHTc3bsQ3slLQ8",
    firebaseAuthDomain:
        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ??
        "futura-c7f12.firebaseapp.com",
    firebaseDatabaseUrl:
        process.env.REACT_APP_FIREBASE_DATABASE_URL ??
        "https://futura-c7f12.firebaseio.com",
    firebaseProjectId:
        process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "futura-c7f12",
    firebaseStorageBucket:
        process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ??
        "futura-c7f12.appspot.com",
    firebaseMessagingSenderId:
        process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? "616491088441",

    cloudinary: {
        apiKey: process.env.REACT_APP_CLOUDINARY_PUBLIC_API_KEY || "",
        cloudName: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "",
        uploadUrl: (cloudName: string, resourceType: string) =>
            `https://api.cloudinary.com/v1_1/${cloudName}/${resourceType}/upload`,
    },

    /**
     * This version is generated by genversion and gets synced with
     * the package.json version during merged to main/master.
     */
    releaseVersion: `restaurant-dashboard@${version}`,
};
